import { ReferralType } from '~/types/referral';
import { DentalSpecialty } from '~/types/specialty';
import type { SpecialtyFormConfig } from '~/types/specialty';

export const prosthodonticConfig: SpecialtyFormConfig = {
  specialty: DentalSpecialty.PROSTHODONTIC,
  displayName: 'Prosthodontist',
  referralTypes: [
    ReferralType.URGENT,
    ReferralType.ROUTINE,
    ReferralType.SYMPTOMATIC,
    ReferralType.ELECTIVE,
    ReferralType.CONSULTATION,
  ],
  diagnosisOptions: [],
  requiresToothSelection: true,
  requiresEmail: false,
};
